<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Transaction Locked</div>
        <div>
          <bread-crumb :bread-crumbs="['Transaction Locked']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <v-row class="mt-1">
          <v-col col="12" md="2">
            <v-autocomplete
              dense
              outlined
              placeholder="Select Country"
            ></v-autocomplete
          ></v-col>
          <v-btn depressed  color="primary" small class="text-capitalize">
            Search
          </v-btn></v-row
        >
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              single-line
              hide-details
              class="me-4"
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          :items="desserts"
          sort-by="calories"
          dense
          class="mt-4 p-1"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" color="primary" @click="editItem(item)">
              mdi-lock
            </v-icon>
          </template>
        </v-data-table>

        <div class="ps-2 font-weight-bold">
          <h5>Unauthorized Transaction</h5>
        </div>

        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          sort-by="calories"
          dense
          class="mt-4 p-1"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" color="primary" @click="editItem(item)">
              mdi-lock
            </v-icon>
          </template>
        </v-data-table>
        <loading :active="loader" :opacity="0.9" color="#ff6b00" />
      </v-card-text>
      <v-dialog persistent v-model="dialog" max-width="700px">
        <v-card>
          <v-card-title>
            <v-row justify="center"><h3 class="mt-3">Confirmation</h3></v-row>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row justify="center">
                <h5 class="text-center mt-3">
                  This will Unlock the Transaction!!
                  <br />
                  Are your sure to Unlock?
                </h5>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed 
              color="primary"
              outlined
              class="text-capitalize"
              @click="dialog = false"
            >
            <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
            </v-btn>
            <v-btn depressed  color="primary" class="text-capitalize">Yes, Unlock!</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </section>
</template>
<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import Loading from "vue-loading-overlay";
// import { alpha } from "@/utils/validate"
export default {
  name: "Transaction Locked ",
  data: () => ({
    dialog: false,
    search: "",
    loader: false,
    headers: [
      {
        text: "SNo",
        sortable: false,
        value: "country_code",
      },
      { text: "Confirmation ID", value: "currency_code" },
      { text: "Pin No", value: "currency_code" },
      { text: "Sender Name", value: "currency_code" },
      { text: "Benificiary Name", value: "currency_code" },
      { text: "Locked By", value: "currency_code" },
      { text: "Mins", value: "currency_code" },
      { text: "Unlock", value: "actions", sortable: false },
    ],
    desserts: [
      {
        country_code: "T000012",
        currency_code: "AA VV",
      },
    ],
  }),
  computed: {},
  components: {
    BreadCrumb,
    Loading,
  },

  watch: {},
  // created () {
  // this.initialize()
  // },
  mounted() {},
  methods: {
    editItem(item) {
      console.log(item);
      this.dialog = true;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
</style>
